import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import axiosInstance from "../../services/axiosInstance";

const instance = axiosInstance();
async function summarizeAttachment(attachment_info) {
  const promise = instance.post(
    `/contract/generate_attachment_summary`,
    attachment_info,
    {
      timeout: 50000,
    }
  );
  toast.promise(promise, {
    loading: "Generating summary...",
    success: "Success!",
    error: "Summary generation failed!",
  });
  const response = await promise;
  return response.data;
}

export function useSummarizeAttachment(resourceId, searchType) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: summarizeAttachment,
    onSuccess: (result) => {
      queryClient.setQueryData(
        ["attachmentSummary", searchType, resourceId],
        result
      );
    },
    onMutate: () => {},
  });
}
